import styled from 'styled-components';
import { Input } from '../Input';

export const Container = styled.div`
  &+& {
    margin-top: 16px;
  }

  & + ${Input} {
    margin-top: 16px;
  }

  small{
    color: ${({ theme }) => theme.colors.error};
    display: block;
    font-size: 12px;
    margin-top: 8px;
  }


`;
